export type MultiDayDatesCalendarProps = {
  allowsPast: boolean;
};

export const MIN_MULTI_DAY_SELECTED_DATES = 2;
